var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.order.consignment.service)?_c('div',[_c('keep-alive',[(_vm.componentFile)?_c(_vm.componentFile,{tag:"component",attrs:{"order":_vm.order}}):_vm._e()],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }